/* ============================================================
   ECLIPSE — Navigation Mobile V2
   Panel navigation engine. Bootstrap remains only the shell.
   ============================================================ */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ecl-nav-v2]';
  var PANEL_SELECTOR = '[data-ecl-nav-panel]';
  var INIT_FLAG = 'eclNavV2Initialized';

  function focusHeading(panel) {
    if (!panel) return;
    var heading = panel.querySelector('[data-ecl-panel-heading]');
    if (!heading) return;

    window.setTimeout(function () {
      try {
        heading.focus({ preventScroll: true });
      } catch (error) {
        heading.focus();
      }
    }, 320);
  }

  function init(root) {
    if (!root || root.dataset[INIT_FLAG] === 'true') return;
    root.dataset[INIT_FLAG] = 'true';

    var stack = [];
    var rootPanel = root.querySelector('[data-ecl-nav-root]');

    function getPanelById(id) {
      if (!id) return null;
      var panel = document.getElementById(id);
      return panel && root.contains(panel) ? panel : null;
    }

    function getActivePanel() {
      return root.querySelector(PANEL_SELECTOR + '.is-active');
    }

    function reset() {
      stack = [];

      root.querySelectorAll(PANEL_SELECTOR).forEach(function (panel) {
        panel.classList.remove('is-active', 'is-behind');
        panel.scrollTop = 0;
      });

      if (rootPanel) {
        rootPanel.classList.add('is-active');
      }

      root.dataset.eclNavDepth = '0';
    }

    function goTo(targetId) {
      var current = getActivePanel();
      var target = getPanelById(targetId);

      if (!current || !target || current === target) return;

      stack.push(current.id);
      current.classList.remove('is-active');
      current.classList.add('is-behind');

      target.classList.remove('is-behind');
      target.classList.add('is-active');
      target.scrollTop = 0;

      root.dataset.eclNavDepth = String(stack.length);
      focusHeading(target);
    }

    function goBack() {
      if (!stack.length) return;

      var current = getActivePanel();
      var previousId = stack.pop();
      var previous = getPanelById(previousId);

      if (!current || !previous) {
        reset();
        return;
      }

      current.classList.remove('is-active', 'is-behind');
      previous.classList.remove('is-behind');
      previous.classList.add('is-active');

      root.dataset.eclNavDepth = String(stack.length);
      focusHeading(previous);
    }

    root.addEventListener('click', function (event) {
      var forward = event.target.closest('[data-ecl-nav-to]');
      if (forward && root.contains(forward)) {
        event.preventDefault();
        goTo(forward.getAttribute('data-ecl-nav-to'));
        return;
      }

      var back = event.target.closest('[data-ecl-nav-back]');
      if (back && root.contains(back)) {
        event.preventDefault();
        goBack();
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft' && stack.length) {
        var activeTag = document.activeElement && document.activeElement.tagName;
        if (activeTag === 'INPUT' || activeTag === 'TEXTAREA') return;
        event.preventDefault();
        goBack();
      }
    });

    root.addEventListener('hidden.bs.offcanvas', reset);
    root.addEventListener('show.bs.offcanvas', function () {
      if (!getActivePanel()) reset();
    });

    reset();
  }

  function initAll(scope) {
    var base = scope || document;

    if (base.matches && base.matches(ROOT_SELECTOR)) {
      init(base);
    }

    if (base.querySelectorAll) {
      base.querySelectorAll(ROOT_SELECTOR).forEach(init);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
